import { PropsWithChildren } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * New top page container which will hold all elements except main content.
 * Needed for migrating to new layout.
 */
const PageTop = ({ children }: PropsWithChildren) => {
  const { pathname } = useLocation();
  const newLayoutRoute = [/\/ship/].some(rx => rx.test(pathname));

  if (!newLayoutRoute) return children;

  return (
    <div className="page-top-wrapper" id="pageTopWrapper">
      {children}
    </div>
  );
};

export default PageTop;
